<template>
  <div class="wrap_box">
    <div class="head">
      <img @click="gohome" src="../../assets/img/login/logo.png" alt="" srcset="">
    </div>
    <div class="box">
    <div class="left">
      <img src="../../assets/img/login/copy.png" alt="" srcset="">
      <p v-html="$t('loginPage_00001')"></p>
      <p class="statement"><a href="https://www.xchargeenergy.com/statement" target="_blank">{{$t('common_45010')}}</a></p>
    </div>
    <div class="right">
      <img src="../../assets/img/login/login_t.png" alt="" srcset="">
      <el-form class="form_box" label-position="top" label-width="80px">
        <el-form-item label="Account">
          <el-input :placeholder="$t('loginPage_00002')" v-model="username" class="inp"></el-input>
        </el-form-item>
        <el-form-item label="Password">
          <el-input :placeholder="$t('loginPage_00003')" v-model="password" :type="flag?'text':'password'" class="inp">
            <img slot="suffix" :src="flag?require('../../assets/img/login/eyes.png'):require('../../assets/img/login/eye.png')" @click="flag=!flag"></img>
          </el-input>
          <div class="reset">
              <a href="./resetPassword.html" target="_blank">{{$t('login_00033')}}</a>
            </div>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" class="btn" @click="submitForm">{{$t('loginPage_00004')}}</el-button>
        </el-form-item>
        <div class="tips">
          <p>{{$t('loginPage_00005')}}<a href="./registerInternational.html?selectedLevel=1">{{$t('loginPage_00006')}}</a></p>
        </div>
      </el-form>
    </div>
    </div>
  </div>
</template>

<script>
import { requestUrl } from "@/assets/utils/constants";
import { ajax } from "@/assets/utils/network";
export default {
  data() {
    return {
      flag: false, // 密码
      username: "",
      password: "",
    };
  },
  created() {
    window.document.title = this.$t("loginPage_00009");
  },
  methods: {
    gohome() {
      window.location.href = "./login.html";
    },
    submitForm() {
      if (this.username == "" || this.password == "") {
        this.$message.error(this.$t("loginPage_00008"));
        return false;
      }
      let user = {
        loginId: this.username,
        password: this.password,
      };
      ajax({
        type: "POST",
        url: requestUrl + "/login",
        data: JSON.stringify(user),
        dataType: "json",
        success: (response) => {
          var info = JSON.parse(response);
          if (info.error != null) {
            if (info.error.code == "NOT_LOGIN") {
              window.location.href = "./login.html?l=0";
            }
            this.$message.error(
              info.error.msg == null ? info.error.code : info.error.msg
            );
            return false;
          }
          if (info.result != null) {
            if (info.result.isSupervisor) {
              document.cookie = `spvid=${info.result.resources[0].resource}`;
            }
            window.location.href = "./preview.html";
          }
        },
        fail: (response) => {
          this.$message.error(response);
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../assets/css/reset.css";
.wrap_box {
  width: 100%;
  min-width: 1080px;
  min-height: 100vh;
  background: url(../../assets/img/login/bg.png) no-repeat;
  background-attachment: fixed;
  background-size: cover;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 100px 0;
  box-sizing: border-box;
  .head {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 2000;
    width: 100%;
    height: 80px;
    line-height: 80px;
    padding-left: 60px;
    box-sizing: border-box;
    background: #ffffff;
    box-shadow: 0px 2px 12px 0px rgba(30, 30, 30, 0.05);
    display: flex;
    align-items: center;
    > img {
      cursor: pointer;
      height: 30px;
    }
  }
  .box{
    display: flex;
    align-items: center;
  }
  .form_box {
    position: relative;
  }
  .left {
    flex: 1;
    margin-right: 20px;
    position: relative;
    > img {
      margin-bottom: 33px;
    }
    > p {
      font-size: 20px;
      font-family: Futura-Medium, Futura;
      font-weight: 500;
      color: #1b2330;
      line-height: 27px;
    }
    .statement {
        position: absolute;
        bottom: -190px;
        left: 0px;

        a {
          font-size: 16px;
          font-weight: 600;
          color: #5278e2;
        }
    }
  }
  .right {
    // flex: 1;
    height: 600px;
    background: #ffffff;
    box-shadow: 0px 2px 12px 0px rgba(30, 30, 30, 0.05);
    border-radius: 20px;
    padding: 50px 80px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    align-items: center;
    > img {
      margin-bottom: 50px;
    }
    /deep/.el-form-item__label {
      font-size: 12px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #464b5c;
      line-height: 17px;
      padding-left: 20px;
    }
    /deep/.el-form-item {
      margin-bottom: 40px;
      &:nth-of-type(2) {
        margin-bottom: 50px;
      }
      &:nth-of-type(3) {
        margin-bottom: 20px;
      }
    }
    .inp {
      width: 420px;
      height: 40px;
      box-shadow: 0px 0px 3px 0px rgba(0, 0, 0, 0.05);
      border-radius: 20px;
      background: #f2f3f7;
      /deep/.el-input__inner {
        border-radius: 20px;
        background: #f2f3f7;
        border: none;
        outline: none;
        padding: 0 40px 0 20px;
      }
      /deep/.el-input__suffix {
        right: 20px;
        cursor: pointer;
      }
    }
    .btn {
      width: 100%;
      border-radius: 20px;
    }
    .tips {
      margin-bottom: 20px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      font-size: 14px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #464b5c;
      a {
        color: #5278e2;
      }
      .statement {
        position: absolute;
        bottom: -50px;
        left: 0px;

        a {
            color: #464b5c;
        }
      }
    }
    .reset{
      display: flex;
      justify-content: flex-end;
      a{
        color: #5278e2;
      }
    }
  }
}
</style>
<style>
input:-webkit-autofill,
input:-webkit-autofill:hover,
input:-webkit-autofill:focus,
input:-webkit-autofill:active {
  transition-delay: 111111s;
  transition: color 11111s ease-out, background-color 111111s ease-out;
}
</style>